import React from 'react'

const InsideSearchIcon2 = () => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="16" height="16" rx="2.54444" fill="white" />
            <path d="M6.18359 12H5.12891V3.54492H6.18359V7.66992H6.24219L9.97461 3.54492H11.3047L7.83008 7.28906L11.6152 12H10.2676L7.09766 8.03906L6.18359 9.04688V12Z" fill="#767676" />
        </svg>

    )
}

export default InsideSearchIcon2
